import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

// **** FOR DEVELOPMENT **** //
// const local_host = 'http://localhost:5000/surgeries';
const remote_host = 'https://server-soroka-demo.herokuapp.com/roomsallocation';

export class OpMngmtCalendar extends Component {

  state = { rooms_allocated: [], full_data_rooms: [], isLoading: true };
    
  getRoomsAllocation = () => {
    fetch(remote_host, {})
      .then(data => data.json())
      .then(data => {
        var rooms_fetched = data.map(room => {
          return {title: 'ward is: ' + room.ward_id + ' room number is: ' + room.room_number, date: room.date, allDay: true}
        })
        this.setState({ rooms_allocated: rooms_fetched, full_data_rooms: data, isLoading: false, EventModalShow: false })
        console.log(this.state.rooms_allocated);
        
    })
      .catch(e => console.log(e));
  }

    eventClickFunc = (info) => {
      
      // alert('Event: ' + info.event.title + ' /nPatient id: ' + this.state.full_data_surgeries[0].patient_id);
      // // alert('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
      // // alert('View: ' + info.view.type);

      console.log(info.event.title);
      info.jsEvent.preventDefault();
    }

    handleDateClick = (start, end, allDay) => { // Need to change Modal to eventClickFunc

      
      }

      componentDidMount() {
        this.getRoomsAllocation();
        
      }

    render() {
      let auth = localStorage.getItem('user');
      

        return (
          <React.Fragment>
    {
      !auth 
         ?
           this.props.history.push(`/`)
         :
         <div>
            
            <FullCalendar 
            editable='false'
            selectable='true' 
            dateClick={this.handleDateClick} 
            defaultView="dayGridMonth" 
            plugins={[ dayGridPlugin, bootstrapPlugin, interactionPlugin, listPlugin, timeGridPlugin ]} 
            events={this.state.rooms_allocated}
            nowIndicator='true'
            eventClick={this.eventClickFunc}
            customButtons= {{
              add_event: {
                  text: 'Add Event',
                  click: function() {
                     alert('-- Surgery insertion form --');
                  }
              }
            }}
            header={{
              left: 'prev,next today,     add_event',
              center: 'title',
              right: 'dayGridMonth,dayGridWeek,listMonth'
            }}

            themeSystem = 'bootstrap'
            />
            </div>
    }
    </React.Fragment>
          
          

        )
    }
}

export default OpMngmtCalendar
